import { post, get, IResponse } from "@Lib/request";
import getUUID from "@Lib/uuid";
import * as ts from "@Types/buyCarMenu";
import { ICommonSelectList, IRaceData } from "@Types/common";
import { EBaseMenuType, EMenuVoteType } from "@Types/constants";
import { host, path } from "./url";

const { usedCarApiV4, uploadApi, usedCarApiV3, newCarApiV2, newCarApiV3, newCarApiV4 } = path;

/** 精选菜单列表 */
export async function getMenuList(params: ts.IMenuListParams): Promise<IResponse<ts.TMenuListResponseData>> {
  return await get(`${newCarApiV3}/buycar/menu/list`, params);
}

/** 菜单详情 */
export async function getMenuInfo(params: { id: string }): Promise<IResponse<ts.TMenuInforResponseData>> {
  return await get(`${newCarApiV3}/buycar/menu/info`, {
    ...params,
  });
}

/** 发布菜单 */
export async function postMenu(
  params: ts.IBuyCarMenuParams,
): Promise<IResponse<{ content: string; activity: any; message: string; qrCodeUrl: string; inquiryId: string }>> {
  return await post(`${newCarApiV3}/buycar/menu`, params);
}

/** 发布菜单草稿 */
export async function postMenuDraft(params: ts.IBuyCarMenuParams): Promise<IResponse<{ content: string }>> {
  return await post(`${newCarApiV3}/buycar/menu/draft`, params);
}

export async function buyCarMenuByCs(params: ts.IBuyCarMenuParams) {
  return await post(`${newCarApiV3}/buycar/menu/cs/complete`, params);
}

/** 获取草稿 */
export async function getMenuDraft(): Promise<IResponse<ts.IBuyCarDraftData>> {
  return await get(`${newCarApiV3}/buycar/menu/info`, {});
}

/** 跑马灯数据 */
export async function getRace(params: { type: EBaseMenuType }): Promise<IResponse<{ list: ts.TRaceData[] }>> {
  return await get(`${newCarApiV3}/race`, params);
}

/** 菜單篩選條件 */
export async function getMenuFilter() {
  return await get(`${newCarApiV3}/buycar/menu/filter`, {});
}

/** pc首页菜单条件 */
export async function fetchBuyCarMenuPcCondition(
  params: ts.IBuyCarMenuPcConditionParams,
): Promise<IResponse<ts.IBuyCarMenuPcCondition>> {
  return await get(`${newCarApiV3}/buy-car/menu/pc-condition`, params);
}

/** pc菜单首页厂牌条件 */
export async function fetchBuyCarMenuPcConditionBrand(params: {
  brandId: number;
}): Promise<IResponse<ts.IBuyCarMenuPcConditionKind>> {
  return await get(`${newCarApiV3}/buy-car/menu/pc-condition/brand`, params);
}

/** pc菜单首页车款条件 */
export async function fetchBuyCarMenuPcConditionKind(params: {
  brandId: number;
}): Promise<IResponse<ts.IBuyCarMenuPcConditionKind>> {
  return await get(`${newCarApiV3}/buy-car/menu/pc-condition/kind`, params);
}

export async function fetchBuyCarMenuPolymer(): Promise<IResponse<ts.IBuyCarMenuPolymer>> {
  return await get(`${newCarApiV3}/buy-car/menu/polymer`);
}

/** 下定菜單投票 */
export async function postMenuVote(params: {
  id: string;
  type: EMenuVoteType;
  shareMid?: string;
}): Promise<IResponse<{ priceVote: ts.IPriceVote }>> {
  return await post(`${newCarApiV3}/buycar/menu/vote`, {
    ...params,
    device_id: getUUID(),
  });
}

/** 发布菜单初始化 */
export async function fetchMenuInit(params: { id?: string; type: "1" | "2" }): Promise<IResponse<any>> {
  return await get(`${newCarApiV3}/buycar/menu/init`, params);
}
export async function fetchBuyCarMenuList(params: any): Promise<IResponse<ts.IBuyCarMenuList>> {
  return await get(`${newCarApiV3}/buycar/menu/list`, params);
}

// 购车菜单状态
export async function fetchMenuUserStatus(params: {
  id: string;
}): Promise<IResponse<{ isFavorite: number; liked: number; likes: number; views: number }>> {
  return await get(`${newCarApiV3}/buycar/menu/user-status`, params);
}

// 购车菜单状态
export async function fetchBuyMenuConditionKind(params: any): Promise<IResponse<any>> {
  return await get(`${newCarApiV3}/buy-car/menu/pc-condition/kind`, params);
}

/** 发布菜单草稿 */
export async function postCommonShared(params: any) {
  return await post(`${newCarApiV4}/common/shared`, params);
}

export async function fetchBuyCarMenuRecommend(params: {
  kindId: number;
  type: number;
  limit: number;
  menuId: string;
}): Promise<IResponse<ts.IBuyCarMenuRecommend>> {
  return await get(`${newCarApiV3}/buycar/menu/recommend`, params);
}
